import { Error, GridContainerFullHeight } from '@ts/storybook';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

interface INotificationsProps {}

const Notifications = (props: INotificationsProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/warnings', { state: { resetHistoryLevel: 0 } });
  }, []);

  return (
    <GridContainerFullHeight horizontalAlign="center">
      <Error message="In working" />
    </GridContainerFullHeight>
  );
};

export default Notifications;
